module.exports = __webpack_public_path__ + "c9ff06f8c72e2bd16dbde8ee45a6cd36.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1153
// module chunks = 0